

<div class="page-layout page-layout-new  blank min-width p-10 newStyles" fxLayout="column">
    <div class="breadcrumb">
        <app-breadcrumb [title]="dataBreadcumbTitle" [description]="dataBreadcumbPages"></app-breadcrumb>
    </div>

    <div *ngIf="loadingPage" class="contenedor-spinner">
        <mat-spinner diameter="60"></mat-spinner>
    </div>

    <div class="new-container" *ngIf="!loadingPage" fxLayout="column" fxLayoutAlign="start center" fxLayoutAlign.xs="center center" fxLayoutAlign.sm="center center" fxFlex="100">
        
        <div class="card card-consulta" fxLayout="column">
            <div class="header-consulta" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
                <h1>FORMULARIOS DE DISCAPACIDAD</h1>
            </div>

            <div class="body-consulta">
                <div class="carpetas-container">
                    <div *ngFor="let carpeta of carpetas; let i = index" class="carpeta-item">
                        <div class="carpeta-header" (click)="toggleCarpeta(i)">
                            <h3>{{ carpeta.titulo }}</h3>
                            <div class="icon-toggle" [class.rotated]="carpeta.expandido">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M7 10L12 15L17 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        
                        <div class="carpeta-content" [class.expanded]="carpeta.expandido">
                            <div class="archivos-list">
                                <div *ngFor="let archivo of carpeta.archivos" class="archivo-item">
                                    <a *ngIf="archivo.url" [href]="archivo.url" target="_blank" class="download-icon">
                                        <mat-icon>cloud_download</mat-icon>
                                    </a>
                                    <span class="archivo-nombre">{{ archivo.nombre }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="back-button-container">
            <button (click)="onBackButton()" class="button-new secondary-blue">
                Atrás
            </button>
        </div>

    </div>

</div>